import { FC, useState } from 'react';
import {
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from '@tanstack/react-table';

import { DataTable } from '@/components/table/data-table';
import { useSimulationShipVisitsColumns } from '@/routes/(app)/(scenarios)/(simulation)/hooks/use-simulation-ship-visits-columns';
import { SimulationRunShipVisit } from '@/routes/(app)/(scenarios)/(simulation)/simulation.types';

interface SimulationShipVisitsTableProps {
  shipVisits: Array<SimulationRunShipVisit>;
  className?: string;
}

export const SimulationShipVisitsTable: FC<SimulationShipVisitsTableProps> = ({
  shipVisits,
  className,
}) => {
  const columns = useSimulationShipVisitsColumns();
  const [sorting, setSorting] = useState<SortingState>([
    { id: 'arrival_time', desc: false },
  ]);

  const table = useReactTable<SimulationRunShipVisit>({
    data: shipVisits,
    columns,
    getRowId: (row) => row.id,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <DataTable
      table={table}
      className={className}
    />
  );
};
